// Project imports

import { logout } from '../../redux/auth';

// Luft HTTP custom Error

export class LuftHttpError extends Error {
  constructor(httpStatus = 0, ...params) {
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, LuftHttpError);
    }
    this.httpStatus = httpStatus;
  }
}

export function loggedUserRequestErrorHandler(dispatch, error, action) {
  if (action) {
    dispatch(action);
  }

  if (error && error.httpStatus && error.httpStatus === 401) {
    dispatch(logout());
  }
}
